import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import UiIcon from "../../../ui/icons/uiIcon";
import {setIsSlabPricingEnabled} from "../../../../actions/sqftSlabFunctions";

const SqftLoadSlabPricingCheckbox = (props) => {
  const {setIsSlabPricingEnabled} = props;
  const [isActive, setActive] = useState(true);

  const checkboxClick = () => {
    setActive(!isActive);
    setIsSlabPricingEnabled(!isActive);
  };
  const isDisabled = false;
  const checkboxClasses = `ui-checkbox ui-checkbox--small${isActive ? " ui-checkbox--checked-svg" : ""}${isDisabled ? " ui-checkbox--disabled" : ""}`

  return (
    <button className="ui-checkbox-wrapper" onClick={checkboxClick} title={isActive ? "Slab pricing" : ""}>
      <div className={checkboxClasses}>
        <div className="ui-checkbox__svg">
          <UiIcon icon="checkmark"/>
        </div>
      </div>
      <span className={"ui-checkbox__label ui-checkbox__text" + (isDisabled ? " ui-checkbox__label--disabled" : "")}>
        <FormattedMessage id="sqft.popup.slab.slabPricing"/>
      </span>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;

  return {
    agreeEmailCheckbox: store.serverState.agreeEmailCheckbox,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSaveButtons,
  };
};

const mapDispatchToProps = {
  setIsSlabPricingEnabled
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabPricingCheckbox)
)
